import React from 'react';
import { Route } from 'react-router-dom';

import './App.css';
import Header from './Components/Common/Header';
import Navigator from './Components/Common/Navigator';
import LoadingSpinner from './Components/Common/LoadingSpinner';

import Home from './Components/Home';
import Casino from './Components/Casino';
import LiveCasino from './Components/LiveCasino';

import Live from './Components/Live';
import Betslip from './Components/Betslip';
import BetslipSingle from './Components/Betslip/BetslipSingle';
import MyAccount from './Components/MyAccount';
import MyBets from './Components/MyBets';

import InPlaySports from './Components/InPlay/Sports';
import InPlaySearch from './Components/InPlay/Search';

import PrematchSports from './Components/Prematch/Sports';
import PrematchSearch from './Components/Prematch/Search';

import Auth from './store/Auth';
import LsportsPull from './store/LsportsPull';
import LsportsAMQ from './store/LsportsAMQ';

function App(props) {
    const GoToPage = (path) => {
        props.history.push(path);
    };

    let customProps = {
        GoToPage: GoToPage,
    };

    return (
        <div>
            <LsportsAMQ></LsportsAMQ>
            <LsportsPull>
                <Auth>
                    <Header {...props} {...customProps} />

                    <Route exact path="/" component={Home} />
                    <Route exact path="/casino" component={Casino} />
                    <Route exact path="/live-casino" component={LiveCasino} />

                    <Route exact path="/live" component={Live} />
                    <Route exact path="/betslip" component={Betslip} />
                    <Route exact path="/betslip-single" component={BetslipSingle} />
                    <Route exact path="/my-account" component={MyAccount} />
                    <Route exact path="/my-bets" component={MyBets} />

                    <Route exact path="/inplay" component={InPlaySports} />
                    <Route exact path="/inplay/search" component={InPlaySearch} />

                    <Route exact path="/prematch" component={PrematchSports} />
                    <Route exact path="/prematch/search" component={PrematchSearch} />

                    <Navigator {...props} {...customProps} />
                </Auth>
            </LsportsPull>
            <LoadingSpinner />
        </div>
    );
}

export default App;
